import { Box, CircularProgress, styled, Typography } from '@mui/material';

export const FrameContainer = styled(Box)({
  width: '100%',
  flex: 1,
  minHeight: 0,
  display: 'flex'
});

const CenteredBox = styled(Box)({
  display: 'flex',
  margin: 'auto',
  flexDirection: 'column',
  alignItems: 'center'
});

export const Spinner = styled((props: any) => {
  return (
    <CenteredBox {...props}>
      <CircularProgress style={{ width: '64px', height: '64px' }} />
      <Typography sx={{ marginTop: '20px', fontSize: '1.2rem' }}>Loading...</Typography>
    </CenteredBox>
  );
})(() => ({}));
